import type { ReactEventHandler } from 'react';

import type { Device } from '../../constants';
import type { BaseComponentProps, ImageSources } from '../../types';
import type { StickerProps } from '../Sticker/Sticker';

export interface WrapperProps {
  className?: string;
  maxHeight?: number;
}

export interface MediaProps extends BaseComponentProps {
  /** @deprecated Use imgSrcs instead */
  imageSource?: string;

  /** @deprecated. Does nothing. Apply styles using className. */
  marginBottom?: unknown;

  altText?: string;
  maxHeight?: number;
  maxWidth?: number;
  height?: number;
  width?: number;
  videoSource?: string;
  mobileVideoSource?: string;
  sourceType?: string;
  wrap?: Device;
  className?: string;

  // TODO: Consider expanding this into multiple parameters since it controls
  // auto play behavior and others.
  showVideoControls?: boolean;
  autoplay?: boolean;

  posterSource?: string;
  onPlay?: ReactEventHandler<HTMLVideoElement>;
  onPause?: ReactEventHandler<HTMLVideoElement>;
  captionsSource?: string;
  isBackgroundVideo?: boolean;
  onTimeUpdate?: ReactEventHandler<HTMLVideoElement>;
  imgSrcs?: ImageSources;
  isDraggable?: boolean;
}

export interface MediaWithStickersProps extends MediaProps {
  mediaClassName?: string;
  stickers?: StickerProps[];
}
